import React from "react";
import PropTypes from "prop-types";
import { formatCurrency, getCopy } from "../helper";
import { NormalPrice, NormalPriceRowWrapper } from "./styled";

const COPY_ID_PREFIX = "OfferAccountPrice";

export default function NormalPriceRow({
  intl,
  offer,
  showCurrencyIsoCodeForPrices,
}) {
  if (!offer?.priceFrequentShipper || !offer?.priceWithoutDiscount) {
    return null;
  }
  return (
    <NormalPriceRowWrapper>
      {getCopy(intl, `${COPY_ID_PREFIX}.normalPrice`)}{" "}
      <NormalPrice>
        {formatCurrency({
          amount: offer?.priceWithoutDiscount?.amount,
          currency: offer?.priceWithoutDiscount?.currencyCode,
          locale: intl.locale,
          showIsoCode: showCurrencyIsoCodeForPrices,
          isCurrencyCodeAvailable: !!offer?.price?.currencyCode,
        })}
      </NormalPrice>
    </NormalPriceRowWrapper>
  );
}

NormalPriceRow.propTypes = {
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  offer: PropTypes.shape({
    price: PropTypes.shape({
      currencyCode: PropTypes.string,
    }),
    priceWithoutDiscount: PropTypes.shape({
      amount: PropTypes.number,
      currencyCode: PropTypes.string,
    }),
    priceFrequentShipper: PropTypes.shape({
      amount: PropTypes.number,
    }),
  }).isRequired,
  showCurrencyIsoCodeForPrices: PropTypes.bool,
};
